export default [
  {
    path: '/traceability-asc',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'TraceabilityAsc',
        component: () => import('./containers/TraceabilityAscContainer'),
      },
    ],
  },
]
